/** Selector de ámbito. El libro cubre Salamanca, Ávila y Segovia, y de cada una la capital y la
 *  provincia: seis colecciones que se leen de una en una. Se agrupan por provincia para que el
 *  selector siga siendo legible. Cambiar de ámbito vuelve al inicio de la sección para no dejar en
 *  la URL una selección que ya no existe. */
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppData } from '../state/AppData';

export function CityPicker() {
  const { city, cities } = useAppData();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  if (cities.length < 2) return null;
  const go = (slug: string) => {
    const next = new URLSearchParams();
    const capa = params.get('capa');
    if (capa) next.set('capa', capa);
    // el ámbito viaja siempre en la dirección, también el de Segovia capital: así las seis puertas
    // se nombran igual y cada una tiene una dirección propia que indexar y compartir
    next.set('ciudad', slug);
    // a la portada de la ciudad, no a la del proyecto: cambiar de ámbito no es salir de la edición
    const q = next.toString();
    navigate(q ? `/ciudad?${q}` : '/ciudad');
  };
  // el orden del libro lo marca el índice de capítulos; aquí solo se agrupa sin reordenar
  const provinces: { province: string; scopes: typeof cities }[] = [];
  for (const c of cities) {
    const g = provinces.find((p) => p.province === c.province);
    if (g) g.scopes.push(c); else provinces.push({ province: c.province, scopes: [c] });
  }
  return (
    <>
      {/* En el móvil los seis botones ocupaban tres filas y un tercio de la pantalla antes de que
          apareciera nada que leer. Ahí se pliega en un solo control; en pantalla ancha siguen los
          botones, que muestran de un vistazo las seis colecciones. Solo uno está visible a la vez. */}
      <label className="masthead__citysel">
        <span className="visually-hidden">Ciudad del libro</span>
        <select value={city.slug} onChange={(e) => go(e.target.value)}>
          {cities.map((c) => <option key={c.slug} value={c.slug}>{c.label}</option>)}
        </select>
      </label>
    <div className="masthead__cities" role="group" aria-label="Ciudad del libro">
      {provinces.map((p) => (
        <span key={p.province} className="masthead__province">
          <span className="masthead__provname">{p.province}</span>
          <span className="segmented">
            {p.scopes.map((c) => (
              <button key={c.slug} type="button" aria-pressed={c.slug === city.slug}
                      aria-label={c.label} onClick={() => go(c.slug)}>
                {c.level === 'capital' ? 'capital' : 'provincia'}
              </button>
            ))}
          </span>
        </span>
      ))}
    </div>
    </>
  );
}
